import Icon from '../components/Icon.vue'

Icon.register({
  certificate: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M458.6 255.9l46 45c13.7 13 7.3 36-10.7 40.3l-62.7 16 17.7 62c5 17.8-11.8 34.7-29.7 29.7l-62-17.7-16 62.7c-4.3 18.2-27.8 24.2-40.3 10.7l-45-46-45 46c-12.6 13.3-35.9 7.9-40.3-10.7l-16-62.7-62 17.7c-17.8 5-34.7-11.8-29.7-29.7l17.7-62-62.7-16c-18-4.3-24.4-27.4-10.7-40.3l46-45-46-45c-13.7-13-7.3-36 10.7-40.3l62.7-16-17.7-62c-5-17.8 11.8-34.7 29.7-29.7l62 17.7 16-62.7c4.3-17.9 27.7-24 40.3-10.7l45 46.3 45-46.3c12.8-13.5 36.1-7 40.3 10.7l16 62.7 62-17.7c17.8-5 34.7 11.8 29.7 29.7l-17.7 62 62.7 16c18 4.3 24.4 27.4 10.7 40.3z'
      }
    ]
  }
})
